import styles from './TypingIndicator.module.css'

export const TypingIndicator = () => {
    return (
        <div className={styles.typingContainer}>
            <div className={styles.typingDot}></div>
            <div className={styles.typingDot}></div>
            <div className={styles.typingDot}></div>
        </div>
    );
};